/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Cta_BtnInputs */

const es_gift_cta_btn = /** @type {(inputs: Gift_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar experiencias`)
};

const gl_gift_cta_btn = /** @type {(inputs: Gift_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar experiencias`)
};

const en_gift_cta_btn = /** @type {(inputs: Gift_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse experiences`)
};

/**
* | output |
* | --- |
* | "Browse experiences" |
*
* @param {Gift_Cta_BtnInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_cta_btn = /** @type {((inputs?: Gift_Cta_BtnInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Cta_BtnInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_cta_btn(inputs)
	if (locale === "en") return en_gift_cta_btn(inputs)
	return es_gift_cta_btn(inputs)
});